const STORAGE_KEY = 'pendingScVid'
export const SC_VID_QUERY_PARAM = 'sc_vid'
export const SC_VID_MAX_LENGTH = 64

export const normalizeScVid = (
  raw: string | null | undefined,
): string | null => {
  const value = raw?.trim().slice(0, SC_VID_MAX_LENGTH)

  return value || null
}

export const getScVidFromSearch = (search: string): string | null =>
  normalizeScVid(new URLSearchParams(search).get(SC_VID_QUERY_PARAM))

export const readPendingScVid = (): string | null => {
  try {
    return normalizeScVid(localStorage.getItem(STORAGE_KEY))
  } catch {
    return null
  }
}

export const persistPendingScVid = (scVid: string): boolean => {
  if (readPendingScVid()) {
    return false
  }

  try {
    localStorage.setItem(STORAGE_KEY, scVid)
    return true
  } catch {
    return false
  }
}

export const clearPendingScVid = (): boolean => {
  try {
    localStorage.removeItem(STORAGE_KEY)
    return true
  } catch {
    return false
  }
}
